<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import BarcodeScanner from "#/assets/iconsDynamic/BarcodeScanner.vue";
import Mark from "#/assets/iconsDynamic/Mark.vue";
import { useThemeStore } from "#/store/theme";

const { t } = useTranslation();
const themeStore = useThemeStore();
</script>

<template>
	<div class="night_scan">
		<div class="night_scan__head">
			<h2 class="night_scan__title">{{ t(`cart.night.scan.title`) }}</h2>
			<p class="night_scan__subtitle">{{ t(`cart.night.scan.subtitle`) }}</p>
		</div>
		<div class="night_scan__video">
			<video
				v-if="themeStore.data?.kiosk_night_video"
				class="night_scan__video-el"
				:src="themeStore.data.kiosk_night_video"
				autoplay
				loop
				muted
				playsinline
			/>
			<div v-else class="night_scan__video-placeholder"></div>
		</div>
		<ol class="night_scan__steps">
			<li class="night_scan__step">
				<div class="night_scan__step-circle">
					<BarcodeScanner class="night_scan__step-icon" />
					<span class="night_scan__step-badge">1</span>
				</div>
				<span class="night_scan__step-text">{{ t(`cart.night.step.1`) }}</span>
			</li>
			<li class="night_scan__step">
				<div class="night_scan__step-circle">
					<Mark class="night_scan__step-icon" />
					<span class="night_scan__step-badge">2</span>
				</div>
				<span class="night_scan__step-text">{{ t(`cart.night.step.2`) }}</span>
			</li>
			<li class="night_scan__step">
				<div class="night_scan__step-circle">
					<svg class="night_scan__step-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
						<rect x="3" y="6" width="18" height="13" rx="2.5" stroke="currentColor" stroke-width="2.2" />
						<path d="M3 10.5h18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" />
					</svg>
					<span class="night_scan__step-badge">3</span>
				</div>
				<span class="night_scan__step-text">{{ t(`cart.night.step.3`) }}</span>
			</li>
			<li class="night_scan__pulse-dot" aria-hidden="true"></li>
		</ol>
	</div>
</template>

<style lang="scss">
@use './nightScanEmpty.scss';
</style>
